import { mockAccordionTitles } from '../../../data/constants';

export const distancesMockValues = {
  distance_sea: '',
  distance_beach: '',
  distance_croisette: '',
  distance_palais: '',
  distance_shop: '',
  distance_track: '',
  distance_gondola: '',
  distance_center: '',
};

const mockTitle = mockAccordionTitles.Distance;

export const distancesMock = [
  {
    title: mockTitle,
    subtitle: 'Distances (km)',
    listId: 'listId6',
    id: 1,
    placeholder: 'Sea',
    name: 'distance_sea',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId6',
    id: 2,
    placeholder: 'Beach',
    name: 'distance_beach',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId6',
    id: 3,
    placeholder: 'Croisette',
    name: 'distance_croisette',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId6',
    id: 4,
    placeholder: 'Palais S.',
    name: 'distance_palais',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId6',
    id: 5,
    placeholder: 'Shops',
    name: 'distance_shop',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId6',
    id: 6,
    placeholder: 'Tracks',
    name: 'distance_track',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId6',
    id: 7,
    placeholder: 'Telecabin',
    name: 'distance_gondola',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
  {
    title: mockTitle,
    listId: 'listId6',
    id: 8,
    placeholder: 'Center',
    name: 'distance_center',
    fieldType: 'text',
    type: 'number',
    classNames: 'w-[47%] sm:w-[30%]',
  },
];
